import { Grid, Typography, Box } from "@mui/material";

interface StatusBadgeConfig {
  bg: string;
  color: string;
}

export const getRenewalStatusBadge = (status: string): StatusBadgeConfig => {
  switch (status) {
    case 'Renewal Completed':
      return { bg: '#e6f4ea', color: '#1e7e34' };
    case 'Renewal Delayed':
      return { bg: '#fde8e8', color: '#c0392b' };
    case 'Renewal Within Current Month':
      return { bg: '#fff8e1', color: '#f57f17' };
    case 'Decommissioned/Retired':
      return { bg: '#e5e7eb', color: '#374151' };
    case 'Renewal Status Unknown':
    default:
      return { bg: '#f3f4f6', color: '#6b7280' };
  }
};

export const DetailRow = ({
  label,
  value,
  isBadge = false,
}: {
  label: string;
  value: string | number | null | undefined;
  isBadge?: boolean;
}) => {
  const badgeConfig = isBadge && typeof value === 'string' ? getRenewalStatusBadge(value) : null;

  return (
    <Grid container sx={{ py: '8px' }}>
      <Grid item xs={5}>
        <Typography sx={{ fontSize: '14px', color: '#71787e', fontWeight: 400 }}>
          {label}
        </Typography>
      </Grid>
      <Grid item xs={7}>
        {badgeConfig ? (
          <Box
            sx={{
              display: 'inline-block',
              px: 2,
              py: '4px',
              borderRadius: '999px',
              backgroundColor: badgeConfig.bg,
            }}
          >
            <Typography
              sx={{
                fontSize: '13px',
                fontWeight: 700,
                color: badgeConfig.color,
                letterSpacing: '0.5px',
              }}
            >
              {value}
            </Typography>
          </Box>
        ) : (
          <Typography sx={{ fontSize: '14px', color: '#1b1f23', fontWeight: 600, wordWrap: 'break-word' }}>
            {value ?? '-'}
          </Typography>
        )}
      </Grid>
    </Grid>
  );
};